// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"Section_scroll-black__A9MRA","title":"Section_title__orJi1"};